import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

export const Route = createFileRoute("/_app/manage/patients/$patientId")({
  parseParams: params => {
    return { patientId: z.coerce.number().int().parse(params.patientId) }
  },
})
